import React from 'react';
import { SketchDumbbell } from './sketch/index.jsx';

/**
 * Top bar: wordmark, week progress, and the two global actions.
 *
 * "Sport" sits next to "Edit" because both act on the whole calendar rather
 * than on one day — the old per-day "+ sport" link repeated the same control
 * in every cell and pinned an activity to a day before you had designed it.
 *
 * @param {{done: number, total: number}} progress
 * @param {boolean} editMode
 * @param {boolean} placing true while a finished sport waits for a day
 * @param {() => void} onToggleEdit
 * @param {() => void} onAddSport
 */
export default function Header({ progress, editMode, placing, onToggleEdit, onAddSport }) {
  const { done, total } = progress;

  return (
    <header className="flex items-center justify-between gap-3 py-4">
      <div className="flex items-baseline gap-3">
        {/* Wordmark: the domain read as one word, with the TLD in accent so it
            works as a mark rather than looking like a URL someone forgot to link */}
        <span className="font-hand text-3xl leading-none">
          habits<span className="text-accent">.ink</span>
        </span>
        {/* Score for the month in view, hidden on the narrowest screens */}
        <span className="hidden text-xs uppercase tracking-widest text-ink-soft sm:inline">
          {total === 0 ? 'nothing planned' : `${done}/${total} this month`}
        </span>
      </div>

      {/* Tight gap and short labels: both buttons have to fit a small phone
          next to the wordmark without wrapping */}
      <div className="flex shrink-0 items-center gap-2">
        <button
          type="button"
          onClick={onAddSport}
          aria-pressed={placing}
          className={`pill-btn gap-1.5 px-3 text-xs uppercase tracking-widest ${
            placing ? 'pill-btn--accent' : ''
          }`}
        >
          <SketchDumbbell />
          Sport
        </button>

        <button
          type="button"
          onClick={onToggleEdit}
          aria-pressed={editMode}
          className={`pill-btn px-3 text-xs uppercase tracking-widest ${
            editMode ? 'pill-btn--accent' : ''
          }`}
        >
          {editMode ? 'Done' : 'Edit'}
        </button>
      </div>
    </header>
  );
}
